import { useContext } from "react";

import CircleButton from "@components/buttons/CircleButton";
import { RichTextareaContext } from "@components/fields/RichTextareaProvider";
import { Colors } from "@utils/colorUtils";
import { IconName } from "@utils/iconUtils";

type Props = {
  submitDisabled?: boolean;
  submitVariant?: "save" | "send";
};

const RichTextareaSubmitButton = ({ submitDisabled, submitVariant = "save" }: Props) => {
  const { uploadsInProgress } = useContext(RichTextareaContext);

  let translationId;
  let icon: IconName;
  let color: Colors;

  // expect potentially more variants here
  switch (submitVariant) {
    case "save":
      translationId = "dictionary.save";
      icon = "checkmark";
      color = "success";
      break;
    case "send":
      translationId = "accessibility.ariaLabels.sendMessage";
      icon = "paperPlane";
      color = "primary";
      break;
  }

  return (
    <CircleButton
      ariaLabelKey={translationId}
      color={color}
      data-test="submit-button"
      disabled={uploadsInProgress.length > 0 || submitDisabled}
      icon={icon}
      type="submit"
    />
  );
};

export default RichTextareaSubmitButton;
